module.exports = __webpack_public_path__ + "img/16g021-11.5f80e6e6.jpg";